<template>
  <div class="place-form" :class="{ 'place-form__mobile': isMobile, 'is-finish': !isNotFinish}">
    <div v-if="!isMobile" class="btn-close" @click="close()">
      <v-icon>mdi-window-close</v-icon>
    </div>
    <template v-if="isNotFinish">
      <template v-if="(!isMobile && isFirstStep && selectedEvent) || (isMobile &&  selectedEvent)">
        <div class="place-form__head">
          <div class="circle">
            <img :src="getIconUrl(selectedEvent.type.type_id)" alt="">
          </div>
          <div class="place-form__head--title">
            <span>{{ selectedEvent.title }}</span>
          </div>
        </div>
        <div v-if="userIsBlocked" class="error-blocked">
          Вы заблокированы до {{ getDateUserBlocked }} включительно
        </div>
        <div class="place-form__description">
          {{ selectedEvent.description }}
        </div>
        <div class="place-form__bread-crumbs">
          <div class="place-form__bread-crumb">
            {{ selectedEvent.site_area }} м2
          </div>
          <div class="place-form__bread-crumb">
            до {{ selectedEvent.number_of_people }} человек
          </div>
        </div>

        <div class="place-form__picture" v-if="selectedEvent && selectedEvent.attachment.length !== 0">
          <div class="image" :style="{backgroundImage: `url(${selectedEvent.attachment[0].url})`}"/>
        </div>
        <div class="place-form__days">
          <div class="place-form__days--title">
            Ближайшие даты
          </div>
          <div class="place-form__days--blocks">
            <div class="day-block"
                 v-for="day in days"
                 :key="`day_${day}`"
                 @click="setDate(day)"
                 :class="{
                          'active': day === formData.date
                        }"
            >
              <div class="name ">
                {{ $moment(day).format('dd') }}
              </div>
              <div class="number">
                {{ $moment(day).format('DD') }}
              </div>
            </div>
          </div>
        </div>
        <div class="place-form__times">
          <div class="place-form__times--title">
            Время
          </div>
          <div class="place-form__times--blocks">
            <div
                class="place-form__times--block"
                v-for="item in getDateTimes"
                :key="item.id"
                @click="setTime(item)"
                :class="{
                          'active' : item.id === formData.time_id,
                          'disable' : checkStatus(item.id)}"
            >
              <div class="time">
                {{ item.time_at.slice(0, 5) }}
              </div>
            </div>
          </div>

        </div>
        <div class="place-form__choose" v-if="!isMobile">
          <v-btn class="btn-choose" :disabled="!formData.time_id" color="#3763FF" @click="nextStep" elevation="0"
                 style="color: #fff;" x-large>
            Выбрать
          </v-btn>
        </div>
      </template>

      <template v-if="(!isMobile && !isFirstStep) || isMobile">

        <div class="place-form__second" v-if="!isMobile">
          <v-btn class="btn-back" @click="backToStepOne" x-small elevation="0" color="#fff" style="color: blue;">
            <v-icon>mdi-chevron-left</v-icon>
            Изменить дату или место
          </v-btn>

        </div>
        <div class="place-form__inputs">
          <ValidationObserver v-slot="{ invalid }">
            <v-form>
              <ValidationProvider name="full_name" rules="required|alpha_spaces" imediate v-slot="{errors}">
                <v-text-field
                    :disabled="loading || userIsBlocked"
                    v-model="formData.full_name"
                    outlined
                    dense
                    :error-messages="errors"
                    placeholder="ФИО"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider name="email" :rules="{required: true, email: true, regex:/^([^а-яА-Я])*$/}" imediate
                                  v-slot="{errors}">
                <v-text-field
                    :disabled="loading || userIsBlocked"
                    v-model="formData.email"
                    :error-messages="errors"
                    outlined
                    dense
                    placeholder="Электронная почта"
                    type="email"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider name="phone" :rules="{regex:/^\+7{1}\ \(\d{3}\)\ \d{3}-\d{2}-\d{2}$/, required: true}"
                                  imediate v-slot="{errors}">
                <v-text-field
                    :disabled="loading || userIsBlocked"
                    v-model="formData.phone"
                    outlined
                    type="phone"
                    dense
                    return-masked-value
                    v-mask="'+7 (###) ###-##-##'"
                    :error-messages="errors"
                    color="deep-purple"
                    placeholder="+7"
                ></v-text-field>
              </ValidationProvider>
              <ValidationProvider name="team_name" rules="required|alpha_spaces" imediate v-slot="{errors}">
                <v-text-field
                    :disabled="loading || userIsBlocked"
                    v-model="formData.team_name"
                    outlined
                    dense
                    :error-messages="errors"

                    placeholder="Название коллектива или творческий псевдоним"
                ></v-text-field>
              </ValidationProvider>
              <vue-tags-input
                  v-model="tag"
                  :tags="formData.persons"
                  class="tags-input"
                  ref="tags-input"
                  placeholder="ФИО участников"
                  @tags-changed="newTags => formData.persons = newTags"
              />
              <ValidationProvider name="category" rules="required|alpha_spaces" imediate v-slot="{errors}">
                <v-text-field
                    :disabled="loading || userIsBlocked"
                    v-model="formData.category"
                    outlined
                    dense
                    :error-messages="errors"
                    placeholder="Жанр выступления"
                ></v-text-field>
              </ValidationProvider>

              <v-file-input
                  v-if="false"
                  :disabled="loading || userIsBlocked"
                  label="Прикрепите фото"
                  outlined
                  dense
                  id="input-file"
                  prepend-icon=""
                  @change="setPhoto"

              ></v-file-input>
              <altcha-widget
                  v-show="!useImageCaptcha || !formData.altcha"
                  ref="captcha"
                  :challenge="captchaChallengeUrl"
                  language="ru"
                  @load="configureCaptcha"
                  @statechange="onCaptchaStateChange"
              ></altcha-widget>
              <div v-if="useImageCaptcha && formData.altcha" class="captcha-verification" :style="captchaPanelStyle">
                <div class="captcha-verification__header">
                  <button type="button" class="captcha-verification__open" :disabled="captchaVerified || loading"
                          @click="imageCaptchaDialog = true" :aria-label="captchaVerified ? 'Проверено' : 'Введите код с картинки'">
                    <span class="captcha-verification__checkbox" :class="{'is-verified': captchaVerified}" aria-hidden="true">
                      <v-icon v-if="captchaVerified" color="white" size="18">mdi-check</v-icon>
                    </span>
                    <span role="status" aria-live="polite">{{ captchaVerified ? 'Проверено' : 'Введите код с картинки' }}</span>
                  </button>
                  <button type="button" class="captcha-verification__reset" :disabled="loading || imageCaptcha.loading"
                          aria-label="Начать проверку заново" @click="resetCaptcha">
                    <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
                      <path d="M20 7a9 9 0 1 0 1 9" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
                      <path d="M20 3v6h-6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
                <div class="captcha-verification__brand">Защищено ALTCHA</div>
              </div>
              <v-dialog v-if="useImageCaptcha" v-model="imageCaptchaDialog" max-width="380">
                <v-card class="image-captcha-dialog">
                  <v-card-title>Введите код с картинки</v-card-title>
                  <v-card-text>
              <section class="image-captcha" aria-label="Проверка по коду">
                <p v-if="!formData.altcha">Сначала отметьте «Я не робот», затем введите код с картинки.</p>
                <template v-else>
                  <v-progress-linear v-if="imageCaptcha.loading" indeterminate color="deep-purple"></v-progress-linear>
                  <img v-if="imageCaptcha.image" :src="imageCaptcha.image" class="image-captcha__image" alt="Изображение кода проверки">
                  <div class="image-captcha__actions">
                    <v-btn text small :disabled="imageCaptcha.loading || loading" @click="loadImageCaptcha">Обновить</v-btn>
                    <v-btn text small v-if="imageCaptcha.id && !formData.image_captcha_token" :loading="imageCaptcha.audioLoading"
                           :disabled="imageCaptcha.loading || loading" @click="loadImageCaptchaAudio">Прослушать код</v-btn>
                  </div>
                  <audio v-if="imageCaptcha.audioUrl" :src="imageCaptcha.audioUrl" controls class="image-captcha__audio" aria-label="Аудиозапись кода проверки"></audio>
                  <v-text-field v-if="imageCaptcha.image" :value="imageCaptcha.answer" @input="setImageCaptchaAnswer"
                                label="Введите шесть цифр с картинки" outlined dense autocomplete="off" inputmode="numeric" maxlength="6"
                                :disabled="imageCaptcha.loading || loading || !!formData.image_captcha_token" hide-details="auto"></v-text-field>
                  <v-btn v-if="imageCaptcha.image && !formData.image_captcha_token" color="#3763FF" dark
                         :loading="imageCaptcha.loading" :disabled="loading || imageCaptcha.answer.length !== 6"
                         @click="verifyImageCaptcha">Подтвердить код</v-btn>
                  <p v-if="formData.image_captcha_token" class="image-captcha__success" role="status">Код подтверждён</p>
                </template>
                <p v-if="imageCaptcha.error" class="image-captcha__error" role="alert">{{ imageCaptcha.error }}</p>
              </section>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="imageCaptchaDialog = false">Закрыть</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <div class="place-form__choose">
                <v-btn @click="submit()" class="btn-choose" :loading="loading"
                       :disabled="loading || invalid || formData.persons.length === 0 || !formData.time_id || !formData.altcha || (useImageCaptcha && !formData.image_captcha_token)"
                       color="#3763FF"
                       elevation="0"
                       style="color: #fff;"
                       x-large>
                  Забронировать
                </v-btn>
              </div>
            </v-form>
          </ValidationObserver>
        </div>
      </template>
    </template>

    <template v-if="!isNotFinish">
      <div class="place-form__finish-title">
        Готово!
      </div>
      <div class="place-form__finish-description">
        Ваша заявка принята.
      </div>
      <div class="place-form__choose">
        <v-btn class="btn-choose" color="#3763FF" @click="close(false)" elevation="0" style="color: #fff;" x-large>
          Хорошо
        </v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {api} from "@/api/api";
import {ValidationProvider, ValidationObserver} from 'vee-validate';
import VueTagsInput from '@johmun/vue-tags-input';
import moment from "moment";

export default {
  name: 'PlaceForm',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueTagsInput
  },
  data: function () {
    return {
      isFirstStep: true,
      isNotFinish: true,
      tag: '',
      loading: false,
      captchaPanelStyle: {},
      imageCaptchaDialog: false,
      imageCaptchaVersion: 0,
      imageCaptcha: {flowToken: '', id: '', image: '', answer: '', loading: false, error: '', audioUrl: '', audioLoading: false},
      formData: {
        date: this.$moment().format('YYYY-MM-DD'),
        form: false,
        password: '',
        phone: '',
        full_name: '',
        persons: [],
        email: '',
        team_name: '',
        category: '',
        file: null,
        time_id: null,
        altcha: null,
        image_captcha_token: null
      },
    }
  },
  computed: {
    ...mapGetters({
      getIsAuthState: 'auth/getIsAuthState',
      getApiToken: 'auth/getApiToken',
      getDataUser: 'auth/getDataUser',
      selectedEvent: 'events/getSelectedEvent',
      days: 'getWeekDates',
      getUserEvents: 'events/getUserEvents'
    }),
    useImageCaptcha() {
      return process.env.VUE_APP_IMAGE_CAPTCHA === 'true';
    },
    captchaVerified() {
      return Boolean(this.formData.altcha && (!this.useImageCaptcha || this.formData.image_captcha_token));
    },
    captchaChallengeUrl() {
      return api.domain + '/api/altcha/challenge';
    },
    userIsBlocked() {
      return this.getDataUser.is_blocked
    },
    getDateTimes() {
      return this.selectedEvent.times;
    },
    isMobile() {
      return this.$parent.isMobile
    },
    getDateUserBlocked() {
      return new moment(this.getDataUser.date_blocked_to).format('DD.MM.YYYY')
    }
  },
  watch: {
    selectedEvent: function (from, to) {
      this.resetCaptcha();
      this.formData.time_id = null
    }
  },
  beforeDestroy() {
    this.clearImageCaptcha();
  },
  methods: {
    ...mapActions({
      set_selected_event: 'events/set_selected_event',
      set_user_events: 'events/set_user_events',
      showAlert: 'showAlert'
    }),
    setPhoto(e) {
      console.log(e)
    },
    getIconUrl(id) {
      try {
        return require(`@/assets/svg/category_${id}.svg`);
      } catch (e) {
        return require(`@/assets/svg/default.svg`)
      }
    },
    setDate(date) {
      this.resetCaptcha();
      this.set_selected_event({id: this.selectedEvent.id, date: this.$moment().format('YYYY-MM-DD')});
      this.formData.date = date;
      this.formData.time_id = null;
    },
    checkStatus(time_id) {
      if (this.selectedEvent && this.selectedEvent.requests) {
        const time_now = this.$moment().diff(this.$moment(this.formData.date).format('YYYY-MM-DD'), 'minutes');
        return this.selectedEvent.requests.some(el => {
          return el.art_event_time_id === time_id && this.$moment().diff(el.date_request, 'minutes') === time_now;
        });
      }
      return false

    },
    setTime(time) {

      const time_now = this.$moment().diff(this.$moment(this.formData.date).format('YYYY-MM-DD'), 'minutes');
      const isItem = this.selectedEvent.requests.find(el => {
        return el.art_event_time_id === time.id && this.$moment().diff(el.date_request, 'minutes') === time_now;
      });

      if (!isItem) {
        this.formData.time_id = time.id;
        return;
      }
      return
    },
    async submit() {
      if (this.loading || !this.formData.altcha || (this.useImageCaptcha && !this.formData.image_captcha_token)) return;
      this.loading = true;

      try {
        const res = await api.events.set_event(this.selectedEvent.id, this.formData.file ? {
          api_token: this.getApiToken,
          // file: this.formData.file,
          time_id: this.formData.time_id,
          date: this.formData.date,
          email: this.formData.email,
          fio: this.formData.full_name,
          phone: this.formData.phone.slice(1),
          members: this.formData.persons,
          team_name: this.formData.team_name,
          category: this.formData.category,
          altcha: this.formData.altcha,
          image_captcha_token: this.formData.image_captcha_token
        } : {
          api_token: this.getApiToken,
          time_id: this.formData.time_id,
          email: this.formData.email,
          date: this.formData.date,
          fio: this.formData.full_name,
          phone: this.formData.phone.slice(1),
          members: this.formData.persons.map(el => el.text),
          team_name: this.formData.team_name,
          category: this.formData.category,
          altcha: this.formData.altcha,
          image_captcha_token: this.formData.image_captcha_token
        })
        this.resetCaptcha();
        this.formData.altcha = null;
        this.isNotFinish = false;

      } catch (e) {
        const data = e.response && e.response.data || {};
        if (e.response && e.response.status === 429) {
          const seconds = Number(e.response.headers['retry-after']) || 60;
          this.showAlert({title: 'Слишком частые запросы', text: 'Повторите попытку через ' + seconds + ' сек. Данные формы сохранены.'});
        } else if (!e.response) {
          this.showAlert({title: 'Не удалось связаться с сервером', text: 'Проверьте соединение и повторите попытку. Данные формы сохранены.'});
        }
        switch (data.message) {
          case "the user has already signed up for that day":
            this.showAlert({
              title: 'У вас уже есть заявка =(',
              text: 'От вас уже есть заявка на ' + data.data.date_request + '. Время: ' + data.data.time_at_request + ' - ' + data.data.time_to_request
            })
            break;

          case "the place is already taken'":
            this.showAlert({
              title: 'Это время уже занято =(',
              text: 'Другой пользователь уже оставил заявку на это время, пожалуйста выберете другое время...'
            })
            break;

          case "bad captcha token":
            this.showAlert({
              title: 'Проверка не пройдена',
              text: 'Пройдите проверку ещё раз и повторите бронирование.'
            })
            break;

          case "captcha unavailable":
            this.showAlert({
              title: 'Проверка временно недоступна',
              text: 'Попробуйте забронировать позже.'
            })
            break;

          case "this request is blocked":
            this.showAlert({
              title: 'Данная заявка уже заблокирована администратором =(',
              text: 'Вы можете выбрать любое другое удобное для Вас время...'
            })
            break;

          case "stock temporary cell is locked":
            this.showAlert({
              title: 'Данная временная ячейка заблокирована администратором до ' + data.data.date_to + ' включительно =(',
              text: 'Вы можете выбрать любое другое удобное для Вас время...'
            })
            break;
        }
        this.resetCaptcha();
        this.formData.altcha = null;
      }

      this.loading = false

    },
    clearImageCaptcha() {
      this.imageCaptchaDialog = false;
      this.imageCaptchaVersion++;
      this.formData.image_captcha_token = null;
      if (this.imageCaptcha.audioUrl) URL.revokeObjectURL(this.imageCaptcha.audioUrl);
      this.imageCaptcha = {flowToken: '', id: '', image: '', answer: '', loading: false, error: '', audioUrl: '', audioLoading: false};
    },
    setImageCaptchaAnswer(value) {
      this.imageCaptcha.answer = String(value || '').replace(/\D/g, '').slice(0, 6);
    },
    imageCaptchaError(error) {
      const response = error.response || {};
      const message = response.data && response.data.message;
      if (response.status === 429) {
        const seconds = Number(response.headers && response.headers['retry-after']) || 60;
        this.imageCaptcha.error = 'Слишком частые запросы. Повторите через ' + seconds + ' сек. Данные формы сохранены.';
      } else if (response.status === 401 || response.status === 403) {
        this.imageCaptcha.error = 'Проверьте доступ к аккаунту и войдите снова. Данные формы сохранены.';
      } else if (message === 'image captcha expired' || message === 'bad captcha token') {
        this.resetCaptcha();
        this.showAlert({title: 'Проверка истекла', text: 'Снова отметьте «Я не робот» и введите новый код. Данные формы сохранены.'});
      } else if (response.status === 409) {
        this.imageCaptcha.error = 'Проверка уже выполняется. Повторите попытку через несколько секунд.';
      } else {
        this.imageCaptcha.error = 'Не удалось загрузить проверку. Повторите попытку. Данные формы сохранены.';
      }
    },
    async loadImageCaptcha() {
      if (!this.useImageCaptcha || !this.formData.altcha || this.loading) return;
      const version = ++this.imageCaptchaVersion;
      const flowToken = this.imageCaptcha.flowToken;
      this.formData.image_captcha_token = null;
      this.imageCaptcha.loading = true;
      this.imageCaptcha.error = '';
      this.imageCaptcha.answer = '';
      this.imageCaptcha.audioLoading = false;
      if (this.imageCaptcha.audioUrl) URL.revokeObjectURL(this.imageCaptcha.audioUrl);
      this.imageCaptcha.audioUrl = '';
      try {
        const response = await api.imageCaptcha.challenge(flowToken ? {flow_token: flowToken} : {altcha: this.formData.altcha});
        if (version !== this.imageCaptchaVersion) return;
        this.imageCaptcha.flowToken = response.data.flow_token;
        this.imageCaptcha.id = response.data.challenge_id;
        this.imageCaptcha.image = response.data.image;
      } catch (error) {
        if (version !== this.imageCaptchaVersion) return;
        if (!flowToken && error.response && error.response.status === 503) {
          this.resetCaptcha();
          this.showAlert({title: 'Проверка временно недоступна', text: 'Попробуйте пройти проверку позже. Данные формы сохранены.'});
        } else this.imageCaptchaError(error);
      } finally {
        if (version === this.imageCaptchaVersion) this.imageCaptcha.loading = false;
      }
    },
    async verifyImageCaptcha() {
      if (this.imageCaptcha.loading || this.imageCaptcha.answer.length !== 6 || !this.imageCaptcha.id) return;
      const version = this.imageCaptchaVersion;
      this.imageCaptcha.loading = true;
      this.imageCaptcha.error = '';
      try {
        const response = await api.imageCaptcha.verify({flow_token: this.imageCaptcha.flowToken, challenge_id: this.imageCaptcha.id, answer: this.imageCaptcha.answer});
        if (version !== this.imageCaptchaVersion) return;
        this.formData.image_captcha_token = response.data.token;
        this.imageCaptchaDialog = false;
      } catch (error) {
        if (version !== this.imageCaptchaVersion) return;
        if (error.response && error.response.data && error.response.data.message === 'image captcha invalid') {
          await this.loadImageCaptcha();
          if (this.formData.altcha && this.imageCaptcha.image) this.imageCaptcha.error = 'Неверный код. Введите код с новой картинки.';
        } else this.imageCaptchaError(error);
      } finally {
        if (version === this.imageCaptchaVersion) this.imageCaptcha.loading = false;
      }
    },
    async loadImageCaptchaAudio() {
      if (!this.imageCaptcha.id || this.imageCaptcha.audioLoading || this.imageCaptcha.loading) return;
      const version = this.imageCaptchaVersion;
      this.imageCaptcha.audioLoading = true;
      try {
        const response = await api.imageCaptcha.audio({flow_token: this.imageCaptcha.flowToken, challenge_id: this.imageCaptcha.id});
        if (version !== this.imageCaptchaVersion) return;
        if (this.imageCaptcha.audioUrl) URL.revokeObjectURL(this.imageCaptcha.audioUrl);
        this.imageCaptcha.audioUrl = URL.createObjectURL(response.data);
      } catch (error) {
        if (version === this.imageCaptchaVersion) this.imageCaptcha.error = 'Не удалось загрузить аудио. Попробуйте обновить картинку.';
      } finally {
        if (version === this.imageCaptchaVersion) this.imageCaptcha.audioLoading = false;
      }
    },
    configureCaptcha(event) {
      const widget = event && event.target || this.$refs.captcha;
      if (!widget || typeof widget.configure !== 'function') return;
      widget.configure({
        fetch: (input, options = {}) => {
          const url = typeof input === 'string' ? input : input.url;
          if (url !== this.captchaChallengeUrl) return Promise.reject(new Error('Unexpected captcha endpoint'));
          const headers = new Headers(options.headers);
          if (this.getApiToken) headers.set('Authorization', `Bearer ${this.getApiToken}`);
          return window.fetch(input, {...options, headers});
        }
      });
    },
    captureCaptchaPanelSize(widget) {
      if (!widget || !widget.shadowRoot || typeof window.getComputedStyle !== 'function') return;
      const panel = widget.shadowRoot.querySelector('.altcha-main');
      if (!panel || !panel.offsetHeight) return;
      const style = window.getComputedStyle(panel);
      this.captchaPanelStyle = {height: style.height, padding: style.padding, borderRadius: style.borderRadius};
    },
    onCaptchaStateChange(event) {
      this.captureCaptchaPanelSize(event.target || this.$refs.captcha);
      const detail = event.detail || {};
      this.formData.altcha = detail.state === 'verified' ? detail.payload : null;
      this.clearImageCaptcha();
      if (this.useImageCaptcha && this.formData.altcha) {
        this.imageCaptchaDialog = true;
        this.loadImageCaptcha();
      }
    },
    resetCaptcha() {
      this.clearImageCaptcha();
      this.formData.altcha = null;
      const widget = this.$refs.captcha;
      if (widget && typeof widget.reset === 'function') widget.reset();
    },
    nextStep() {
      if (this.getIsAuthState) {
        this.isFirstStep = false;
        this.formData.altcha = null;
        this.$nextTick(() => this.configureCaptcha());
        return
      }
      this.$router.push({name: 'login'});
    },
    backToStepOne() {
      this.resetCaptcha();
      this.isFirstStep = true;
    },
    close(hide = true) {
      this.resetCaptcha();

      this.isFirstStep = true;
      this.isNotFinish = true;
      this.tag = '';
      this.loading = false;
      this.formData = {
        date: this.$moment().format('YYYY-MM-DD'),
        form: false,
        password: '',
        phone: '',
        full_name: '',
        persons: [],
        email: '',
        team_name: '',
        category: '',
        file: null,
        time_id: null,
        altcha: null,
        image_captcha_token: null
      }

      if (!this.isMobile && hide) {
        this.$emit('close')
      }

    }
  }

}
</script>

<style lang="scss">
.place-form {
  width: 100%;

  box-sizing: border-box;
  background: #ffff;

  padding: 24px;
  display: flex;
  flex-direction: column;

  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;

  position: absolute;
  top: 24px;
  max-width: 500px;
  right: 104px;
  z-index: 100;
  max-height: 100vh;

  @media screen and (max-width: 1439px) {
    padding: 16px;
    right: 52px;
  }

  @media screen and (max-width: 768px) {
    
  }

  &__mobile {
    box-shadow: none;
    position: unset;
    max-height: unset;
    max-width: unset;
  }

  &__picture {
    width: 308px;
    height: 120px;

    .image {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
    }
  }


  .btn-close {
    position: absolute;
    right: 10px;
    top: 10px;
  }


  &__finish-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: start;

    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    /* identical to box height, or 133% */


    color: #000000;
    text-align: left;

    @media screen and (max-width: 1439px) {
      font-size: 16px;
      line-height: 20px;
    }

    @media screen and (max-width: 768px) {
      font-size: 18px;
      line-height: 16px;
    }
  }


  .tags-input {
    margin-bottom: 20px;

    max-width: 100%;
  }

  &__finish-description {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    /* or 143% */

    text-align: start;

    color: #000000;

    margin-top: 24px;

    @media screen and (max-width: 1439px) {
      font-size: 12px;
    }

    @media screen and (max-width: 768px) {
      font-size: 16px;
    }

  }

  &__head {
    display: grid;
    align-items: center;
    grid-auto-flow: column;
    grid-template-columns: max-content;
    gap: 10px;

    .circle {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: #C4C4C4;

      img {
        width: 100%;
        height: 100%;
      }

      /*@media screen and (max-width: 1439px) {
        display: none;
      }*/

    }

    &--title {

      font-weight: 400;
      font-size: 18px;
      line-height: 24px;
      color: #000000;
      text-align: start;


      @media screen and (max-width: 1439px) {

        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        max-width: 100%;

      }

      @media screen and (max-width: 768px) {
        max-width: 228px;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;

      }
    }
  }

  .v-text-field--outlined fieldset {
    border: 1px dashed;
  }


  &__inputs {
    margin-top: 24px;

    @media screen and (max-width: 1439px) {
      margin-top: 20px;
    }

    @media screen and (max-width: 768px) {
      margin-top: 10px;
    }
  }

  &__second {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  &__description {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #000000;
    text-align: start;
    margin-top: 16px;

    @media screen and (max-width: 1439px) {
      margin-top: 12px;
      font-size: 12px;
    }

    @media screen and (max-width: 768px) {
      margin-top: 10px;
    }
  }

  &__bread-crumbs {
    display: flex;
    align-items: center;
    margin-top: 8px;
    flex-wrap: wrap;
  }

  &__bread-crumb {
    padding: 4px 16px;

    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    /* identical to box height, or 143% */


    color: #FFFFFF;
    border-radius: 4px;
    margin-left: 8px;

    @media screen and (max-width: 1439px) {
      padding: 4px 10px;
    }

    @media screen and (max-width: 768px) {
      margin-top: 10px;
    }

    &:nth-child(1) {
      background: #6F6F6F;
      margin-left: 0;
    }

    &:nth-child(2) {
      background: #979797;

    }
  }

  &__picture {
    margin-top: 24px;
    width: 266px;
    height: 177px;

    background-size: cover;
    background-repeat: no-repeat;


    @media screen and (max-width: 1439px) {
      margin-top: 18px;
    }

    @media screen and (max-width: 768px) {
      margin-top: 10px;
    }
  }

  &__days {
    display: flex;
    flex-direction: column;
    margin-top: 24px;

    align-items: flex-start;

    @media screen and (max-width: 1439px) {
      margin-top: 15px;
    }

    @media screen and (max-width: 768px) {
      margin-top: 10px;
    }

    .title {
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 24px;
      /* identical to box height, or 133% */

      @media screen and (max-width: 1439px) {
        font-size: 16px;
      }

      @media screen and (max-width: 768px) {
        font-size: 14px;
      }


      color: #000000;
    }

    &--blocks {
      display: flex;
      gap: 8px;

      @media screen and (max-width: 1439px) {
        margin-top: 5px;
      }

      @media screen and (max-width: 768px) {

      }


      .day-block {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        transition: all .5s ease-in-out;

        width: 48px;
        height: 48px;
        border-radius: 4px;

        border: 1px solid #868686;

        margin-left: 8px;
        margin-top: 5px;
        cursor: pointer;

        @media screen and (max-width: 1439px) {
          width: 38px;
          height: 38px;
        }

        @media screen and (max-width: 768px) {
          width: 35px;
          height: 35px;
        }

        &:nth-child(1) {
          margin-left: 0;
        }


        .name {
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          /* or 143% */
          color: #4F4F4F;
          text-transform: uppercase;


          @media screen and (max-width: 1439px) {
            font-size: 12px;
          }

          @media screen and (max-width: 768px) {
            font-size: 10px;
          }
        }

        .number {
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          /* or 143% */


          color: #4F4F4F;

          @media screen and (max-width: 1439px) {
            font-size: 12px;
          }

          @media screen and (max-width: 768px) {
            font-size: 10px;
          }
        }

        &.active {
          background: #3763FF;
          border-radius: 4px;
          border: 0px solid #fff;
          transition: all .5s ease-in-out;

          .name, .number {
            color: #fff;
          }
        }
      }
    }
  }

  &__times {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 24px;

    @media screen and (max-width: 1439px) {
      margin-top: 10px;
    }

    @media screen and (max-width: 768px) {
      font-size: 10px;
    }

    &--title {
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 24px;
      /* identical to box height, or 133% */


      color: #000000;


      @media screen and (max-width: 1439px) {
        font-size: 16px;
      }

      @media screen and (max-width: 768px) {
        font-size: 14px;
      }
    }

    &--blocks {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-top: 18px;

      @media screen and (max-width: 1439px) {
        margin-top: 10px;
      }

      @media screen and (max-width: 768px) {
        margin-top: 10px;
      }
    }

    &--block {
      padding: 8px 16px;
      align-items: center;
      justify-content: center;
      border: 1px solid #868686;
      box-sizing: border-box;
      border-radius: 4px;

      margin-left: 8px;
      cursor: pointer;

      @media screen and (max-width: 1439px) {
        padding: 4px 10px;
      }

      @media screen and (max-width: 768px) {
        padding: 8px 10px;
      }

      .time {
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        /* identical to box height, or 150% */


        color: #4F4F4F;

        @media screen and (max-width: 1439px) {
          font-size: 14px;
        }

        @media screen and (max-width: 768px) {
          font-size: 12px;
        }

      }

      &:nth-child(1) {
        margin-left: 0;
      }

      &.active {
        background: #3763FF;
        border-radius: 4px;

        border: 0px solid #fff;

        .time {
          color: #fff;
        }
      }

      &.disable {
        background: #DEDEDE;
        border: 1px solid #A5A5A5;

        .time {
          color: #A5A5A5;
        }
      }
    }
  }


  &__choose {
    margin-top: 24px;
    width: 100%;


    @media screen and (max-width: 1439px) {
      margin-top: 10px;
    }

    @media screen and (max-width: 768px) {

    }

    .btn-choose {
      width: 100%;
    }
  }

  .error-blocked {
    margin-top: 10px;
    width: 100%;
    padding: 10px;
    background: #f5c2c7;
    color: #842029;
    border: 1px solid #842029;
    border-radius: 4px;
  }
}

.image-captcha { margin-top: 16px; padding: 16px; border: 1px solid #dedede; border-radius: 8px; }
.image-captcha__image { display: block; width: 100%; max-width: 320px; height: auto; margin: 12px auto; }
.image-captcha__actions { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 8px; }
.image-captcha__audio { display: block; width: 100%; margin-bottom: 12px; }
.image-captcha__error { color: #c62828; font-size: 14px; margin-top: 12px; }
.image-captcha__success { color: #237a3b; margin-top: 12px; }
.image-captcha-status { margin-top: 8px; font-size: 14px; }
.image-captcha-status .image-captcha__success { margin: 0; }
.image-captcha-dialog .image-captcha { padding: 0; margin: 0; border: none; }
.image-captcha-dialog .image-captcha__image { max-width: 280px; margin: 0 auto 12px; }
.image-captcha-dialog .v-card__title { font-size: 18px; line-height: 24px; word-break: normal; }
.image-captcha-dialog .image-captcha__actions { gap: 0; }
.captcha-verification { box-sizing: border-box; border: 1px solid #ccc; border-radius: 6px; padding: .75rem; background: #fff; display: flex; flex-direction: column; justify-content: space-between; gap: .5rem; font: inherit; }
.captcha-verification__header { display: flex; align-items: center; justify-content: space-between; gap: .5rem; font: inherit; line-height: 1.25; color: #111; }
.captcha-verification__open { display: flex; align-items: center; gap: .5rem; min-width: 0; text-align: left; font: inherit; line-height: 1.25; color: inherit; }
.captcha-verification__open:disabled { color: inherit; cursor: default; }
.captcha-verification__checkbox { box-sizing: border-box; width: 22px; height: 22px; flex: 0 0 22px; border: 1px solid #999; border-radius: 5px; display: flex; align-items: center; justify-content: center; background: #fff; }
.captcha-verification__checkbox.is-verified { background: #008a00; border-color: #008a00; }
.captcha-verification__reset { display: flex; align-items: center; justify-content: center; width: 24px; height: 24px; flex: 0 0 24px; color: #666; }
.captcha-verification__reset:disabled { opacity: .5; cursor: default; }
.captcha-verification__open:focus-visible, .captcha-verification__reset:focus-visible { outline: 2px solid #3763ff; outline-offset: 3px; border-radius: 4px; }
.captcha-verification__brand { margin: 0; text-align: right; color: #111; opacity: .7; font-size: .7rem; line-height: 1.25; }
</style>

<style>
.place-form altcha-widget { --altcha-max-width: 100%; --altcha-color-primary: #3763FF; }

.image-captcha { margin-top: 16px; padding: 16px; border: 1px solid #dedede; border-radius: 8px; }
.image-captcha__image { display: block; width: 100%; max-width: 320px; height: auto; margin: 12px auto; }
.image-captcha__actions { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 8px; }
.image-captcha__audio { display: block; width: 100%; margin-bottom: 12px; }
.image-captcha__error { color: #c62828; font-size: 14px; margin-top: 12px; }
.image-captcha__success { color: #237a3b; margin-top: 12px; }
</style>
